
import React from 'react';
import TerminalComponent from '../../components/Terminal/TerminalComponent';
import { Language } from '../../types';

interface TerminalTemplateProps {
  language: Language;
  onBack: () => void;
  onExecuteCommand: (action: string, params?: any) => void;
}

const TerminalTemplate: React.FC<TerminalTemplateProps> = ({ language, onBack, onExecuteCommand }) => {
  
  const parseAndExecute = async (input: string) => {
    const parts = input.trim().toLowerCase().split(' ');
    const base = parts[0];
    const action = parts[1];
    const target = parts.slice(2).join(' ');

    const isAr = language === 'ar';

    if (base === 'flow') {
      if (action === 'create') {
        onExecuteCommand('flow-create', { name: target });
        return { success: true, msg: isAr ? `تم إنشاء التدفق: ${target || 'جديد'}` : `Flow created: ${target || 'Untitled'}` };
      }
      if (action === 'delete') {
        onExecuteCommand('flow-delete', { id: target });
        return { success: true, msg: isAr ? `جاري حذف التدفق المستهدف` : `Deleting targeted flow` };
      }
    }

    if (base === 'plan') {
       if (action === 'upgrade') {
          onExecuteCommand('plan-upgrade', { type: target });
          return { success: true, msg: isAr ? `جاري تنفيذ طلب الترقية إلى ${target.toUpperCase()}` : `Processing upgrade to ${target.toUpperCase()}` };
       }
    }

    if (base === 'service') {
       if (action === 'enable' || action === 'disable') {
          onExecuteCommand(`service-${action}`, { id: target });
          return { success: true, msg: isAr ? `تم تحديث حالة الخدمة: ${target}` : `Service status updated: ${target}` };
       }
    }

    return { success: false, msg: isAr ? `أمر غير معروف: ${base}. اكتب help للمساعدة` : `Unknown command: ${base}. Type 'help' for assist.` };
  };

  return (
    <TerminalComponent 
      language={language}
      onExecute={parseAndExecute}
      onBack={onBack}
    />
  );
};

export default TerminalTemplate;
